export const environment = {
  production: false,

  // // DEV
  // apiUrl: 'https://osaapi.expertapps.com.sa/api',
  // signalR: 'https://osaslr.expertapps.com.sa/hubs',
  // dbgate: 'https://dbgate.expertapps.com.sa',
  // apiClient: 'https://hopscotch.expertapps.com.sa',
  // tQuery: 'https://hopscotch.expertapps.com.sa',

  // // DEV2
  appUrl: 'https://osa2.expertapps.com.sa',
  apiUrl: 'https://osaapi2.expertapps.com.sa/api',
  signalR: 'https://osaslr2.expertapps.com.sa/hubs',
  dbgate: 'https://dbgate.expertapps.com.sa',
  apiClient: 'https://hopscotch.expertapps.com.sa',
  tQuery: 'https://hopscotch.expertapps.com.sa',

  // TEST
  // appUrl: '',
  // apiUrl: 'https://osatestapi.expertapps.com.sa/api',
  // signalR: 'https://osaslrtest.expertapps.com.sa/hubs',
  // dbgate: 'https://dbgatetest.expertapps.com.sa',
  // apiClient: 'https://hopscotchtest.expertapps.com.sa',


  googleSiteKey: '6Lcz56QqAAAAAPhEQkyFr0KBNtpRj-dc-GcxQL2c',
  googleApiKey: '6Lcz56QqAAAAANCi0wq8xYHwBCc7YIS_3qpeo9dE',
};
